 import React, { useState, useRef, useEffect } from "react";
import "./Navbar.css";
import Logo from "../assets/logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const searchRef = useRef(null);
  const navigate = useNavigate();

  const isLoggedIn =!!localStorage.getItem("token");

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current &&!searchRef.current.contains(e.target)) {
        setResults([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const allPages = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about-us" },
    { name: "Contact Us", path: "/contact-us" },
    { name: "Blog", path: "/blog" },
    { name: "Login", path: "/login" },
    { name: "Sign Up", path: "/signup" },
    { name: "Awareness", path: "/awareness" },
    { name: "Report", path: "/report" },
    { name: "Event", path: "/event" },
    { name: "Campaign", path: "/campaign" },
    { name: "Feedback", path: "/feedback" },
    { name: "Join as Volunteer", path: "/join-as-volunteer" },
    { name: "Air", path: "/awareness/air" },
    { name: "Air Types", path: "/awareness/air-type" },
    { name: "Air Causes", path: "/awareness/air-causes" },
    { name: "Air Effect", path: "/awareness/air-effect" },
    { name: "Water", path: "/awareness/water" },
    { name: "Plant", path: "/awareness/plant" },
    { name: "Land", path: "/awareness/land" },
    { name: "Birds", path: "/awareness/birds" },
    { name: "Animal", path: "/awareness/animal" },
    { name: "Animal Detail", path: "/awareness/animal-detail" },
    { name: "SunLight", path: "/awareness/sunlight" },
    { name: "Donate", path: "comingSoon" },
    { name: "Gallery", path: "comingSoon" },
    { name: "Team", path: "comingSoon" },
  ];

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value.length > 1) {
      const filtered = allPages.filter((p) =>
        p.name.toLowerCase().includes(value.toLowerCase())
      );
      setResults(filtered);
    } else {
      setResults([]);
    }
  };

  const goToPage = (path) => {
    if (path === "comingSoon") {
      alert("Ye page abhi ban raha hai. Jald aayega! 🚀");
    } else {
      navigate(path);
    }
    setQuery("");
    setResults([]);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userToken");
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    setMenuOpen(false);
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={Logo} alt="Logo" />
        <div className="text-logo">
          <span className="eco">Eco </span>
          <span className="vibe">Vibe</span>
        </div>
      </div>

      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul className={`nav-links ${menuOpen? "active" : ""}`}>
        <li><NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink></li>
        <li><NavLink to="/about-us" onClick={() => setMenuOpen(false)}>About Us</NavLink></li>
        <li><NavLink to="/contact-us" onClick={() => setMenuOpen(false)}>Contact Us</NavLink></li>
        <li><NavLink to="/blog" onClick={() => setMenuOpen(false)}>Blog</NavLink></li>
      </ul>

      <div className="search-container" ref={searchRef} style={{ position: "relative" }}>
        <input
          type="text"
          placeholder="Search everything..."
          className="search-input"
          value={query}
          onChange={handleSearch}
        />
        <button className="search-btn" onClick={() => results[0] && goToPage(results[0].path)}>
          Search
        </button>

        {query.length > 1 && (
          <div style={{
            position: "absolute",
            top: "45px",
            left: 0,
            background: "white",
            width: "250px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            borderRadius: "8px",
            zIndex: 999,
            maxHeight: "300px",
            overflowY: "auto",
          }}>
            {results.length > 0? (
              results.map((page) => (
                <div
                  key={page.name}
                  onClick={() => goToPage(page.path)}
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #eee",
                    color: "black",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.background = "#e6ffe6")}
                  onMouseOut={(e) => (e.currentTarget.style.background = "white")}
                >
                  <span>{page.name}</span>
                  {page.path === "comingSoon" && (
                    <span style={{ fontSize: "10px", color: "orange" }}>Coming Soon</span>
                  )}
                </div>
              ))
            ) : (
              <div style={{ padding: "10px", color: "gray" }}>No results found</div>
            )}
          </div>
        )}
      </div>

      <div className="buttons">
        {!isLoggedIn && (
          <>
            <Link to="/login"><button>Log in</button></Link>
            <Link to="/signup"><button className="signup-btn">Sign Up</button></Link>
          </>
        )}

        {isLoggedIn && (
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;